export class ErrorResponse {
    status?: number;
    code: string;
    message: string;
    messageArgs?: any;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/error.response.i.ts